// components/FAQ.jsx
import React, { useState } from "react";
import { faqData } from "../data/faqData";
import "../components/NewFAQ.css";

const NewFAQ = ({ faqKey, title = "Frequently Asked Questions" }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = faqData[faqKey] || [];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-wrapper">
      <h2 className="faq-heading">{title}</h2>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span className={`arrow ${openIndex === index ? "open" : ""}`}>
                {">"}
              </span>
            </div>

            {openIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewFAQ;
